export default {
  aac: 'file',
  css: 'file',
  json: 'file',
  xml: 'file',
  ogg: 'file',
  opus: 'file',
  otf: 'file',
  rtf: 'file',
  mp2t: 'file',
  ttf: 'file',
  webp: 'file',
  woff: 'file',
  woff2: 'file',
  plain: 'file',
  '3gpp': 'file',
  '3gpp2': 'file',
  wav: 'file',
  bmp: 'img',
  gif: 'img',
  jpeg: 'img',
  jpg: 'img',
  png: 'img',
  tiff: 'img',
  tif: 'img',
  mpeg: 'mov',
  webm: 'mov',
  mdb: 'mdb',
  bdd: 'bdd',
  html: 'html',
  txt: 'txt',
  csv: 'xls',
  ods: 'xls',
  xls: 'xls',
  xlsx: 'xls',
  odp: 'ppt',
  ppt: 'ppt',
  pptx: 'pptx',
  msword: 'doc',
  odt: 'doc',
  doc: 'doc',
  docx: 'doc',
  pdf: 'pdf',
  mpp: 'mpp',
  one: 'one',
  pub: 'pub',
  vsd: 'vsd',
  xsn: 'xsn',
  gzip: 'zip',
  zip: 'zip',
  rar: 'zip',
  heic: 'img'
};